module.exports = __webpack_public_path__ + "static/media/ibjja.3093fcf3.png";